import * as queueAPI from '@debbie/cortex/dist/api/queue.js';
import React, { useEffect } from 'react';
import THEME from '../theme.js';
const QueueListProgress = (props) => {
    const [progress, setProgress] = React.useState(null);
    const [total, setTotal] = React.useState(null);
    const getStatus = async () => {
        if (typeof progress === 'number' && progress === total) {
            return;
        }
        const r = await queueAPI.getProgress(props.listHandlerId);
        setProgress(r.processed);
        setTotal(r.total);
    };
    useEffect(() => {
        const tId = setInterval(() => {
            getStatus();
        }, 500);
        return () => {
            setProgress(null);
            setTotal(null);
            clearInterval(tId);
        };
    }, []);
    if (progress === null || total === null || progress === total) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("div", { style: {
                backgroundColor: THEME.COLOR_ACCENT,
                padding: '1px 0',
                width: `${(progress / total) * 100}%`,
                transition: 'width 0.5s ease-in-out',
            } }),
        React.createElement("p", { style: {
                marginTop: '5px',
                fontSize: '0.8em',
            } },
            progress,
            " / ",
            total)));
};
export default QueueListProgress;
//# sourceMappingURL=QueueListProgress.js.map